import React from "react";
import "../../src/App.css";
import queryString from "query-string";
import axios from "axios";
import { Image } from "rebass";
import Loader from "react-loader-spinner";
import tick from "../assets/img/tick.png";
import failed from "../assets/img/error.png";
var convert = require("xml-js");

class Verification extends React.Component {
  componentDidMount() {
    if (this.props.match.params && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      var userToken = this.props.match.params.token;
      var xmlBodyStr = `<?xml version="1.0" encoding="utf-8"?>
      <API3G>
        <CompanyToken>04B1037B-5BEB-4CD9-B9BD-24BF710DBFE1</CompanyToken>
        <Request>verifyToken</Request>
        <TransactionToken>${parsed.TransactionToken}</TransactionToken>
      </API3G>`;

      var config = {
        headers: {
          "Content-Type": "text/xml",
          "Access-Control-Allow-Origin": "*"
        }
      };
      axios
        .post(
          "https://cors-anywhere.herokuapp.com/https://secure.3gdirectpay.com/API/v6/",
          xmlBodyStr,
          config
        )
        .then(res => {
          var result1 = convert.xml2js(res.data, {
            compact: true,
            spaces: 4
          });

          if (String(result1.API3G.Result._text) === "000") {
            //get user access

            axios
              .put(
                "http://41.220.143.49:7500/api/user/addpaymenttoken",
                {},
                {
                  headers: {
                    Authorization: `Basic ${userToken}`,
                    "Access-Control-Allow-Origin": "*"
                  }
                }
              )
              .then(res =>
                this.setState({
                  isVerified: true,
                  passInBack: true,
                  isLoading: false
                })
              )
              .catch(err => {
                this.setState({
                  isLoading: false
                });
                console.log(err);
              });
          } else {
            console.log(result1);
          }
        })
        .catch(err => {
          this.setState({ isVerified: false, isLoading: false });
          console.log(err);
        });
    }
  }

  state = {
    isVerified: false,
    isLoading: true,
    passInBack: false
  };
  render() {
    const { isLoading, isVerified, passInBack } = this.state;
    return (
      <div
        style={{
          marginTop: "10%",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <div>
          <Loader
            visible={isLoading}
            type="Oval"
            color="orange"
            height={40}
            width={40}
          />
        </div>

        {isVerified && isLoading === false ? (
          <div
            style={{
              marginTop: 10,
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <Image
              src={tick}
              sx={{
                width: ["30%"]
              }}
            />
            <p style={{ fontWeight: "bold", fontSize: 30 }}>Successfully</p>
            {passInBack ? (
              <p>Sasa Waweza kurudi nyuma(Back) ili uanze kusoma</p>
            ) : (
              <p>Contact Us, Seems there is an error</p>
            )}
          </div>
        ) : (
          <div>
            {isLoading === false ? (
              <div
                style={{
                  marginTop: 10,
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column"
                }}
              >
                <Image
                  src={failed}
                  sx={{
                    width: ["30%"]
                  }}
                />
                <p style={{ fontWeight: "bold", fontSize: 30 }}>Failed</p>
                <p>Malipo Hayajakamilika</p>
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

export default Verification;
